"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const removeFieldMappingBraces = (value) => lodash_1.get(value.match(/\{\{(.*)\}\}/), [1], value);
exports.default = removeFieldMappingBraces;
